import { render, staticRenderFns } from "./group-create-popup.html?vue&type=template&id=8327cf30&scoped=true&"
import script from "./group-create-popup.js?vue&type=script&lang=js&"
export * from "./group-create-popup.js?vue&type=script&lang=js&"
import style0 from "./group-create-popup.scss?vue&type=style&index=0&id=8327cf30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8327cf30",
  null
  
)

export default component.exports